module.exports = __webpack_public_path__ + "20dd650e38feb7192436ed1aa1000473.gif";